import {
  Box,
  Button,
  Flex,
  Stack,
  Text,
  TextInput,
  Tooltip,
  Badge,
} from "@mantine/core";
import { useContext, useState } from "react";
import IdeaContext from "../IdeaContext";
import IdeaAttributes from "./IdeaAttributes";
import { IconArrowLeft } from "@tabler/icons";
import { saveIdea } from "../../../Api";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { useHover } from "@mantine/hooks";
import { ArchiveIcon, ConvertIcon } from "../../../icons/x-symbol-svgrepo-com";
import { OverflownText } from "../../OverflownText";
import DuplicateIdeaModal from "./DuplicateIdeaModal";
import { useUserPermissions } from "../../../hooks/useUserPermissions";

const Header = ({
  reviewMode,
  setReviewMode,
  description,
  title,
  setTitle,
  isLongTitle,
  longTitleCheck,
  descWidth,
  titleWidth,
  isLongDescription,
  duplicateIdea,
  setDuplicateIdea,
  duplicateIdeaModalOpened,
  setDuplicateIdeaModalOpened
}: {
  reviewMode: boolean;
  setReviewMode: any;
  description: string;
  title: string;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  isLongTitle: boolean;
  longTitleCheck: any;
  descWidth: number;
  titleWidth: number;
  isLongDescription: boolean;
  duplicateIdea: any;
  setDuplicateIdea: any;
  duplicateIdeaModalOpened: boolean;
  setDuplicateIdeaModalOpened: any;
}) => {
  const { idea, setIdea, setMatchesTrigger, isGenerated, ideaState } = useContext(IdeaContext);
  const { canEditIdeas } = useUserPermissions();

  const isReadOnly = isGenerated || !canEditIdeas;
  const auth0 = useAuth0();
  const navigate = useNavigate();
  const { hovered, ref } = useHover();
  const [editing, setEditing] = useState(false);

  const updateIdeaTitle = (title: string) => {
    if (idea && idea.title !== title) {
      const ideaObj = {
        id: idea._id,
        title: title,
      };
      saveIdea(ideaObj, auth0)
        .then((response) => {
          console.log(response);
          setMatchesTrigger(0)
          setIdea({...idea, title})
        })
        .catch((e: any) => console.log(e));
    }
  };

  const handleBackClick = () => {
    // Retrieve the last saved filters or set a default empty string
    const lastFilters = sessionStorage.getItem('lastFilters') || '';
    const subPageKey = sessionStorage.getItem('subPageKey') || '';
    if(subPageKey){
      navigate(`/ideas/${subPageKey}${lastFilters}`);
    }else {
    // Navigate to the home page with the last saved parameters
      navigate(`/${lastFilters}`);
    }
  };

  return (
    <Flex
      pl={16}
      w="100%"
      bg="#F8F8FB"
      justify="space-between"
    >
      <Box maw="40vw" sx={{
        alignContent: 'center',
        display:'flex',
        flexDirection: 'column',
        marginTop:'2px'
      }}>
        <Flex h={24}>
          <Tooltip label="Back to ideas page">
            <Stack
              mt={4}
              align="center"
              justify="center"
              h={20}
              w={20}
              mr={4}
              sx={{ cursor: "pointer" }}
              onClick={handleBackClick}
            >
              <IconArrowLeft size={19} />
            </Stack>
          </Tooltip>
          {ideaState === "archived" && 
            <Flex
              sx={{
                backgroundColor: "#FF8700",
                borderRadius: "50px",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff"
              }}
              px={8}
              mx={4}
              gap={5}
            >
              <ArchiveIcon color="#fff"/>
              <Text fz={12}>Archived</Text>
            </Flex>
          }

          <Tooltip label={title} disabled={editing || isReadOnly} maw={600} multiline>
            {!isReadOnly  ? <Flex
              ref={ref}
              p={3}
              align="center"
              sx={{
                border: editing
                  ? "1.6px solid rgba(92, 92, 235, 0.3)"
                  : hovered
                    ? "1.6px solid #D8D8DB"
                    : "1.6px solid #f8f8fb",
                borderRadius: "6px",
              }}
            >
              
              <TextInput
                fw={600}
                placeholder="Enter title"
                radius={0}
                variant="default"
                w= {editing ? "49vw" : (titleWidth + 10)}
                sx={{
                  display: 'block',
                  textOverflow: "ellipsis",
                    
                  whiteSpace: "nowrap",
                  marginTop: "1px",
                  [`@media (max-width: 1600px)`]: {
                    maxWidth: "45vw",
                  },
                  [`@media (max-width: 1400px)`]: {
                    maxWidth: "40vw",
                  },
                }}
                maw="55vw"
                styles={() => ({
                  input: {
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    border: "none",
                    fontSize: "20px",
                    fontWeight: "bold",
                    margin: "0px",
                    padding: "0px",
                    background:"#f8f8fb",
                    "&:focus-within": {
                      border: "none",
                    },
                    minHeight: 20,
                    height: 24,
                  },
                })}
                value={title}
                onClick={() => {
                  if (!editing) {
                    setEditing(true);
                  }
                }}
                onChange={(e: any) => {
                  setTitle(e.target.value);
                  longTitleCheck();
                }}
                onBlur={(e: any) => {
                  setEditing(false);
                  updateIdeaTitle(e.target.value);
                }}
              />
            </Flex> : 
              <Flex align='center'>
                <OverflownText fw={600} fz={20} maw={'50vw'}>{title}</OverflownText>
              </Flex>
            
            }
          </Tooltip>
        </Flex>
        {!reviewMode && (
          // <Tooltip label={description} multiline disabled={!isLongDescription} w={600} >
          <Flex
            mt={2}
            ml={27}
            maw='1100px'
          >
            <Tooltip position="bottom" label={ description } maw={600} multiline>
              <Flex h={25} sx={{ cursor: isReadOnly ? 'default' :"pointer" }} onClick={ () => 
              {if(isReadOnly){
                return
              }
              else
                setReviewMode(!reviewMode)} }>
                {/* <OverflownText
                    lineClamp={1}
                    ta="start"
                    maw= {editing ? "46vw" : "30vw"}
                    fz={14}
                    sx={{minHeight: 25}}
                  > */}
                <Text
                  ta="start"
                  sx={{
                    display: 'block',
                    textOverflow: "ellipsis",
                    
                    whiteSpace: "nowrap",
                    marginTop: "1px",
                    [`@media (max-width: 1600px)`]: {
                      maxWidth: "45vw",
                    },
                    [`@media (max-width: 1400px)`]: {
                      maxWidth: "40vw",
                    },
                  }}
                  maw={'55vw'} lineClamp={1}>
                  {description || ""}
                </Text>
                    
                {/* </OverflownText> */}
              </Flex>
            </Tooltip>
              
            {isLongDescription && <Flex sx={{ cursor: isReadOnly ? 'default'  :"pointer" }} onClick={ () => 
              
              setReviewMode(!reviewMode) }>
              <Tooltip position="bottom" label="Edit description" disabled={isReadOnly}>
                <Text
                  ml="6px" 
                  mt={3}
                  color="#5C5CEB"
                  sx={{ cursor: " pointer" }}
                  fz={14}
                  lineClamp={1}
                  w={150}
                >
                  {description?.length === 0 ? "Add description" : "More"}
                </Text>
              </Tooltip>
            </Flex>}
          </Flex>
          // </Tooltip>
          
        )}
      </Box>
      <Box w="40vw" mt={3.8}>
        <IdeaAttributes
          duplicateIdea={duplicateIdea}
          setVerifyOpened={setDuplicateIdeaModalOpened}
        />
      </Box> 
      {/* duplicate idea modal */}
      <DuplicateIdeaModal
        idea={idea}
        duplicateIdea={duplicateIdea}
        verifyOpened={duplicateIdeaModalOpened}
        setVerifyOpened={setDuplicateIdeaModalOpened}
      />
    </Flex>
  );
};

export default Header;
